import React from "react";

import styles from "./ScreenTutorialButton.module.scss";

/**
 * @param {Function} onClick - function to run onClick
 */
const ScreenTutorialButton = props => {
    return (
        <button
            className={styles["screen-tutorial-button"]}
            onClick={() => window.open("https://compliancygroup.freshdesk.com/support/home")}
        >
            <i className="fas fa-info-circle" />
            SUPPORT
        </button>
    );
};

export default ScreenTutorialButton;
